import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { orderService } from "../services";

const GroupOrderGuest = () => {
  const navigate = useNavigate();
  const { inviteToken: routeToken } = useParams();
  const [searchParams] = useSearchParams();
  const inviteToken =
    routeToken || searchParams.get("inviteToken") || searchParams.get("token") || "";

  const [joining, setJoining] = useState(true);

  useEffect(() => {
    const join = async () => {
      if (!inviteToken) {
        toast.error("Invalid invite link");
        navigate("/");
        return;
      }

      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        toast.error("Please sign in to join this group order");
        navigate("/");
        return;
      }

      try {
        setJoining(true);
        const response: any = await orderService.joinGroupOrder(inviteToken);
        if (response.status && response.data?.sessionId) {
          toast.success("Joined group order");
          navigate(`/group-order/${response.data.sessionId}`, { replace: true });
        } else {
          toast.error(response.message || "Failed to join group order");
          navigate("/");
        }
      } catch (error: any) {
        toast.error(error?.message || "Failed to join group order");
        navigate("/");
      } finally {
        setJoining(false);
      }
    };

    join();
  }, [inviteToken, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-900">
      <p className="text-[#050505] dark:text-white font-urbanist text-lg">
        {joining ? "Joining group order..." : "Redirecting..."}
      </p>
    </div>
  );
};

export default GroupOrderGuest;
